<template>
    <div style="padding:10px; border:1px solid #a0a0a0;height: 200px;overflow: auto">
        <h3 class="title-header">VATAN SOSYAL HİZMETLER TİCARET LİMİTED ŞİRKETİ İNTERNET SİTESİ GİZLİLİK VE ÇEREZ
            POLİTİKASI</h3>

        <p class="middle-p">
            <strong>VATAN SOSYAL HİZMETLER TİCARET LİMİTED ŞİRKETİ</strong> (<span class="highlight">Şirket</span>)
            tarafından işletilen (<a href="https://desafe.com.tr">www.desafe.com.tr</a>) internet sitesini ziyaret
            edenlerin (<span class="highlight">Veri Sahibi</span>) gizliliğini
            koruma önde gelen ilkelerimiz arasındadır. İnternet Sitesi Gizlilik ve Çerez Politikası (<span
                class="highlight">Politika</span>) ile; veri
            sahiplerinin kişisel verilerinin işlenmesi, çerez politikası ve internet sitesi gizlilik politikası hakkında
            açıklamalar yapılmaktadır.
        </p>

        <strong class="strong-title">Gizlilik ve Çerez Politikası</strong>

        <ul class="middle-ul">
            <li>
                <strong>Veri Sahiplerinin Kişisel Verilerinin İşlenmesi</strong>
                <p class="middle-p">
                    İnternet sitemizi ziyaret etmeniz sırasında elde edilen
                    kişisel veriler, Desecure tarafından 6698 sayılı Kişisel Verilerin Korunması Kanunu
                    (<span class="highlight">Kanun</span>) uyarınca aşağıda belirlenen kapsamda işlenebilecektir.
                    Kişisel verilerinizin işlenmesine ilişkin detaylı bilgilere, (<a href="https://desafe.com.tr">www.desafe.com.tr</a>)
                    internet adresinden ulaşabilirsiniz.
                </p>
            </li>
            <li>
                <strong>Kişisel Verilerinizin İşlenme Amacı</strong>
                <p class="middle-p">
                    İnternet Sitemizi ziyaret etmeniz dolayısıyla elde edilen kişisel verileriniz aşağıda sıralanan
                    amaçlarla Desecure tarafından Kanun’un 5. ve 6. maddelerine uygun olarak işlenebilecektir.
                </p>
            </li>
            <li>Desecure tarafından yürütülen ticari faaliyetlerin gerçekleştirilmesi için ilgili iş birimlerimiz
                tarafından gerekli çalışmaların yapılması ve buna bağlı iş süreçlerinin yürütülmesi,
            </li>
            <li>Desecure tarafından sunulan ürün ve hizmetlerden ilgili kişileri faydalandırmak için gerekli
                çalışmaların iş birimlerimiz tarafından yapılması ve ilgili iş süreçlerinin yürütülmesi,
            </li>
            <li>Desecure tarafından sunulan ürün ve hizmetlerin ilgili kişilerin beğeni, kullanım alışkanlıkları ve
                ihtiyaçlarına göre özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması için gerekli olan
                aktivitelerin planlanması ve icrası.
            </li>
            <li>
                <strong>Kişisel Verilerinizin Aktarıldığı Taraflar ve Aktarım Amacı</strong>
                İnternet sitemizi ziyaret etmeniz dolayısıyla elde edilen kişisel verileriniz, kişisel verilerinizin
                işlenme amaçları doğrultusunda, iş ortaklarımıza, tedarikçilerimize kanunen yetkili kamu kurumlarına ve
                özel kişilere Kanun’un 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları
                kapsamında aktarılabilecektir.
            </li>
            <li>
                <strong>Kişisel Verilerinizin Toplanma Yöntemi Ve Hukuki Sebebi</strong>
                Kimliğinizi belirli ya da belirlenebilir kılan her türlü bilgi “kişisel veri”dir. İnternet sitemizi
                ziyaretiniz kapsamında kişisel verileriniz Kanun’da yer alan veri işleme şartlarına uygun olarak
                İnternet Sitemizi ziyaret etmeniz dolayısıyla teknik iletişim dosyaları olan çerezler (cookies)
                vasıtasıyla toplanmaktadır.
            </li>
            <li>
                <strong>Veri Sahiplerinin Hakları</strong>
                Veri sahibi olarak aşağıdaki haklara sahip olduğunuzu bildiririz:
                <ul>
                    <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
                    <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
                    <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
                        öğrenme,
                    </li>
                    <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
                    <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme
                        ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini
                        isteme,
                    </li>
                    <li>Kanun’a ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini
                        gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini
                        isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere
                        bildirilmesini isteme,
                    </li>
                    <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize
                        bir sonucun ortaya çıkması durumunda buna itiraz etme
                    </li>
                    <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın
                        giderilmesini talep etme.
                    </li>
                </ul>
                Yukarıda sıralanan haklarınıza yönelik başvurularınızı, Desafe Veri Sahibi Başvuru
                Formu’nu doldurarak tarafımıza iletebilirsiniz. Talebinizin niteliğine göre en kısa sürede ve en geç
                otuz gün içinde başvurularınız ücretsiz olarak sonuçlandırılacaktır; ancak işlemin ayrıca bir maliyet
                gerektirmesi halinde Kişisel Verileri Koruma Kurulu tarafından belirlenecek tarifeye göre ücret talep
                edilebilecektir.
            </li>

        </ul>

    </div>
</template>

<script>
    export default {
        name: "PrivatyContent"
    }
</script>

<style scoped>

</style>
